import { Outlet, useLocation, useRoutes } from "react-router";
import { HomeLayout } from "../layouts/Home";
import Landing from "../pages/landing";
import AuthGuard from "../guards/Auth";
import SignedGuard from "../guards/Signed";
import { AppLayout } from "../layouts/App";
import AppPage from "../pages/app";
import GoogleLoginPage from "../pages/google_login";
import PrivacyPage from "../pages/this/privacy";
import TermsPage from "../pages/this/terms";
import GurujiMainApp from "../pages/guruji";
import IndexPage from "../pages/main";
import AboutPage from "../pages/this/about";
import ContactPage from "../pages/this/contact";
import CareerPage from "../pages/this/career";
import RefundPage from "../pages/this/refund";
import BrochurePage from "../pages/resources/brochure";
import PortfolioPage from "../pages/resources/porfolio";
import RazorPayIntegrationPage from "../pages/services/razorpay_integ";
import PayuIntegrationPage from "../pages/services/payu_integ";
import PaypalIntegrationPage from "../pages/services/paypal_integ";
import StripeIntegrationPage from "../pages/services/stripe_integ";
import ClaudeIntegrationPage from "../pages/services/claude_integ";
import OpenAIIntegrationPage from "../pages/services/openai_integ";
import CrossDevelopmentPage from "../pages/services/cross_development";
import DesktopDevelopmentPage from "../pages/services/desktop_development";
import MobileDevelopmentPage from "../pages/services/mobile_dev";
import StartupIdeaPage from "../pages/services/startup_idea";
import AdobeXDPage from "../pages/services/adobe_xd";
import FigmaPage from "../pages/services/figma";
import ColorsGuidePage from "../pages/services/colors_guide";
import ModernLayoutPage from "../pages/services/modern_layout";
import StartupDesignPage from "../pages/services/startup_design";
import WordpressPage from "../pages/services/wp";
import ShopifyPage from "../pages/services/shopify";
import EcommercePage from "../pages/services/ecommerce";
import CustomWebsitePage from "../pages/services/custom_website";
import PortfolioWebsitePage from "../pages/services/portfolio";
import PaymentsPage from "../pages/solutions/payments";
import DomainsPage from "../pages/solutions/domains";
import SEOPage from "../pages/solutions/seo";
import HostingPage from "../pages/solutions/hosting";
import WebDevelopmentPage from "../pages/solutions/webdev";
import HireHelpPage from "../pages/this/hire_help";
import ServicesPage from "../pages/services";
import PartnershipPage from "../pages/this/partnershio";
import AIMLPage from "../pages/services/ai_ml";

export function Router() {
  return useRoutes([
    {
      path: "/",
      element: (
        <AppPage>
          <Outlet />
        </AppPage>
      ),
      children: [
        {
          path: "/",
          element: <IndexPage />,
        },

        /** This */
        {
          path: "about",
          element: <AboutPage />,
        },
        {
          path: "contact",
          element: <ContactPage />,
        },
        {
          path: "career",
          element: <CareerPage />,
        },
        {
          path: "privacy",
          element: <PrivacyPage />,
        },
        {
          path: "terms",
          element: <TermsPage />,
        },
        {
          path: "refund",
          element: <RefundPage />,
        },
        {
          path: "hire_help",
          element: <HireHelpPage />,
        },
        {
          path: "partnership",
          element: <PartnershipPage />
        },

        /** Solutions */

        {
          path: "solutions",
          children: [
            {
              path: "",
              element: <h1>Root</h1>
            },
            {
              path: "web_development",
              element: <WebDevelopmentPage />
            },
            {
              path: "hosting",
              element: <HostingPage />
            },
            {
              path: "domains",
              element: <DomainsPage />
            },
            {
              path: "seo",
              element: <SEOPage />
            },
            {
              path: "payments",
              element: <PaymentsPage />
            }
          ]
        },
        
        /** Services */

        {
          path: "services",
          children: [
            {
              path: "",
              element: <ServicesPage />
            },
            {
              path: "ai",
              element: <AIMLPage />
            },
            {
              path: "portfolio_website",
              element: <PortfolioWebsitePage />
            },
            {
              path: "custom_website",
              element: <CustomWebsitePage />
            },
            {
              path: "ecommerce",
              element: <EcommercePage />
            },
            {
              path: "shopify_website",
              element: <ShopifyPage />
            },
            {
              path: "wordpress_website",
              element: <WordpressPage />
            },

            {
              path: "startup_design",
              element: <StartupDesignPage />
            },
            {
              path: "modern_layout",
              element: <ModernLayoutPage />
            },
            {
              path: "colors_guide",
              element: <ColorsGuidePage />
            },
            {
              path: "figma",
              element: <FigmaPage />
            },
            {
              path: "adobe_xd",
              element: <AdobeXDPage />
            },

            {
              path: "startup_idea",
              element: <StartupIdeaPage />
            },
            {
              path: "mobile_development",
              element: <MobileDevelopmentPage />
            },
            {
              path: "desktop_development",
              element: <DesktopDevelopmentPage />
            },
            {
              path: "cross_development",
              element: <CrossDevelopmentPage />
            },

            {
              path: "openai_integration",
              element: <OpenAIIntegrationPage />
            },
            {
              path: "claude_integration",
              element: <ClaudeIntegrationPage />
            },
            {
              path: "stripe_integration",
              element: <StripeIntegrationPage />
            },
            {
              path: "paypal_integration",
              element: <PaypalIntegrationPage />
            },
            {
              path: "payu_integration",
              element: <PayuIntegrationPage />
            },
            {
              path: "razorpay_integration",
              element: <RazorPayIntegrationPage />
            }
          ]
        },

        /** Resources */
        {
          path: "resources",
          children: [
            {
              path: "",
              element: <h1>Resources</h1>
            },
            {
              path: "portfolio",
              element: <PortfolioPage />
            },
            {
              path: "brochure",
              element: <BrochurePage />
            }
          ]
        }
      ]
    }
  ]);
}
